var _excluded = ["value", "label", "helper", "disabled", "checked", "error", "style", "className", "inverted", "indeterminate", "theme"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useEffect, useRef } from 'react';
import { bool, string, shape, oneOfType, node } from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { hexToRgb } from '@gympass/yoga-common';
import { Check, Rectangle } from '@gympass/yoga-icons';
import { HiddenInput } from '../../shared';
var CheckboxWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  ", "\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "cursor: not-allowed" : '';
});
var CheckMark = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  border-style: solid;\n\n  flex-shrink: 0;\n\n  ", "\n"])), function (_ref2) {
  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      inverted = _ref2.inverted,
      error = _ref2.error,
      indeterminate = _ref2.indeterminate,
      _ref2$theme$yoga = _ref2.theme.yoga,
      _ref2$theme$yoga$colo = _ref2$theme$yoga.colors,
      primary = _ref2$theme$yoga$colo.primary,
      feedback = _ref2$theme$yoga$colo.feedback,
      elements = _ref2$theme$yoga$colo.elements,
      white = _ref2$theme$yoga$colo.white,
      checkbox = _ref2$theme$yoga.components.checkbox;
  var borderColor = elements.selectionAndIcons;
  var bgColor = 'transparent';
  var checkColor = checkbox.checked.icon.color;

  if (error) {
    var _feedback$attention = feedback.attention;
    borderColor = _feedback$attention[1];

    if (checked || indeterminate) {
      var _feedback$attention2 = feedback.attention;
      bgColor = _feedback$attention2[1];
    }
  } else if (disabled) {
    borderColor = checkbox.disabled.border.color;

    if (checked || indeterminate) {
      bgColor = checkbox.disabled.backgroundColor;
      borderColor = elements.lineAndBorders;
    }
  } else if (checked || indeterminate) {
    borderColor = primary;
    bgColor = primary;
    checkColor = checkbox.checked.icon.color;

    if (inverted) {
      bgColor = white;
      borderColor = white;
      checkColor = primary;
    }
  } else if (inverted) {
    borderColor = white;
    checkColor = primary;
  }

  return "\n    width: " + checkbox.size + "px;\n    height: " + checkbox.size + "px;\n\n    margin-right: " + checkbox.margin.right + "px;\n\n    background-color: " + bgColor + ";\n\n    border-radius: " + checkbox.border.radius + "px;\n    border-width: " + checkbox.border.width + "px;\n    border-color: " + borderColor + ";\n\n    svg {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n\n      fill: " + checkColor + ";\n\n      transform: translate(-50%, -50%);\n    }";
});
var Label = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  cursor: pointer;\n\n  ", "\n"])), function (_ref3) {
  var checkbox = _ref3.theme.yoga.components.checkbox;
  return "\n    font-size: " + checkbox.label.font.size + "px;\n    color: " + checkbox.label.font.color + ";\n  ";
});
var Shadow = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  display: none;\n\n  ", "\n"])), function (_ref4) {
  var checkbox = _ref4.theme.yoga.components.checkbox;
  return "\n    width: " + checkbox.size + "px;\n    height: " + checkbox.size + "px;\n    border-radius: " + checkbox.hover.border.radius + "px;\n  ";
});
var CheckboxStyled = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  ", "\n"])), function (_ref5) {
  var checked = _ref5.checked,
      inverted = _ref5.inverted,
      disabled = _ref5.disabled,
      indeterminate = _ref5.indeterminate,
      _ref5$theme$yoga = _ref5.theme.yoga,
      _ref5$theme$yoga$colo = _ref5$theme$yoga.colors,
      primary = _ref5$theme$yoga$colo.primary,
      elements = _ref5$theme$yoga$colo.elements,
      white = _ref5$theme$yoga$colo.white,
      checkbox = _ref5$theme$yoga.components.checkbox;
  var shadowSize = Math.round(checkbox.size * 0.33);

  var shadowColor = function shadowColor() {
    if (inverted) {
      return white;
    }

    return checked || indeterminate ? primary : elements.backgroundAndDisabled;
  };

  return "\n      " + (disabled ? "pointer-events: none" : '') + "\n\n      " + Label + ":active,\n      &:focus-within,\n      &:hover  {\n        " + Shadow + " {\n          display: block;\n        }\n      }\n\n      &:hover {\n        " + Shadow + " {\n          background-color: " + hexToRgb(shadowColor(), 0.25) + ";\n\n          box-shadow: 0 0 0 " + shadowSize + "px\n            " + hexToRgb(shadowColor(), 0.25) + ";\n        }\n      }\n\n      &:focus-within {\n        " + Shadow + " {\n          background-color: " + hexToRgb(shadowColor(), 0.5) + ";\n\n          box-shadow: 0 0 0 " + shadowSize + "px\n            " + hexToRgb(shadowColor(), 0.5) + ";\n        }\n      }\n\n      " + Label + ":active {\n        " + Shadow + " {\n          background-color: " + hexToRgb(shadowColor(), 0.75) + ";\n\n          box-shadow: 0 0 0 " + shadowSize + "px\n            " + hexToRgb(shadowColor(), 0.75) + ";\n        }\n      }\n    ";
});
var HelperWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  ", "\n"])), function (_ref6) {
  var checkbox = _ref6.theme.yoga.components.checkbox;
  return "\n    margin-top: " + checkbox.helper.margin.top + "px;\n  ";
});
var Helper = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref7) {
  var error = _ref7.error,
      _ref7$theme$yoga = _ref7.theme.yoga,
      feedback = _ref7$theme$yoga.colors.feedback,
      checkbox = _ref7$theme$yoga.components.checkbox;
  return "\n    color: " + (error ? feedback.attention[1] : checkbox.helper.font.color) + ";\n\n    font-size: " + checkbox.helper.font.size + "px;\n  ";
});
/** The checkbox component is used when the user needs to select one or more
 * items on a task. This component can also allow the user to turn an option on
 * or off.  */

var Checkbox = function Checkbox(_ref8) {
  var value = _ref8.value,
      label = _ref8.label,
      helper = _ref8.helper,
      disabled = _ref8.disabled,
      checked = _ref8.checked,
      error = _ref8.error,
      style = _ref8.style,
      className = _ref8.className,
      inverted = _ref8.inverted,
      indeterminate = _ref8.indeterminate,
      checkbox = _ref8.theme.yoga.components.checkbox,
      rest = _objectWithoutPropertiesLoose(_ref8, _excluded);

  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  });
  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    style: style,
    className: className,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(CheckboxStyled, {
    checked: checked,
    indeterminate: indeterminate,
    inverted: inverted,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(Shadow, null), /*#__PURE__*/React.createElement(CheckMark, {
    disabled: disabled,
    checked: checked,
    error: error,
    inverted: inverted,
    indeterminate: indeterminate
  }, checked && !indeterminate && /*#__PURE__*/React.createElement(Check, {
    width: checkbox.size,
    height: checkbox.size
  }), indeterminate && /*#__PURE__*/React.createElement(Rectangle, {
    width: checkbox.size,
    height: checkbox.size
  })), /*#__PURE__*/React.createElement(HiddenInput, _extends({
    type: "checkbox",
    ref: inputRef,
    checked: checked,
    disabled: disabled
  }, rest)), label)), (helper || error) && /*#__PURE__*/React.createElement(HelperWrapper, null, /*#__PURE__*/React.createElement(Helper, {
    error: error
  }, error || helper)));
};

Checkbox.propTypes = {
  label: oneOfType([string, node]),

  /** short helper text under checkbox */
  helper: string,
  value: string,
  checked: bool,
  disabled: bool,
  inverted: bool,
  error: string,

  /** if true, the component appears indeterminate */
  indeterminate: bool,

  /** set a style to the checkbox container */
  style: shape({}),
  className: string
};
Checkbox.defaultProps = {
  label: undefined,
  value: undefined,
  helper: undefined,
  checked: false,
  disabled: false,
  inverted: false,
  indeterminate: false,
  error: undefined,
  style: undefined,
  className: undefined
};
Checkbox.displayName = 'Checkbox';
export default withTheme(Checkbox);